import React, { Component } from 'react'
import { DragSource, DropTarget } from 'react-dnd'

const specificationDrag = {
  beginDrag(props, monitor, component) {
    return {
      id: props.id
    }
  }
}
const specificationDrop = {
  drop(props, monitor) {
    const dragId = monitor.getItem().id
    const dropId = props.id
    // console.log(dragId+':'+dropId)
    if (dragId === dropId) {
      return
    }
    // monitor.getItem().id = hoverId
    props.handleDrag(dragId, dropId)
  }
  // drop(props, monitor) {
  //   console.log('drop props:', props)
  //   console.log('result:', monitor.getItem())
  //   // typeof props.store.$drop == 'function' && props.store.$drop()
  // }
}
const collectDrag = (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  isDragging: monitor.isDragging(),
  dragId: monitor.getItem()?.id
})
const collectDrop = (connect, monitor) => {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver()
  }
}

class UploadItem extends Component {
  // 给一个偏移量，方便让用户看出是置于元素前面还是后面
  computedTranslateX = () => {
    const { isDragging, isOver, id, dragId } = this.props
    if (!isOver || isDragging || !dragId) {
      return 0
    }
    const [typeDrag, dragIndex] = dragId.split('-')
    const [typeDrop, dropIndex] = id.split('-')
    // 在两个列表之间拖，肯定是置于元素之后
    if (typeDrag !== typeDrop) {
      return -20
    }
    // 判断拖动方向，往后还是往前拖
    if (+dragIndex > +dropIndex) {
      return 20
    } else {
      return -20
    }
  }
  render() {
    const {
      node,
      isDragging,
      connectDragSource,
      connectDropTarget
    } = this.props
    const opacity = isDragging ? 0.5 : 1
    const translateX = this.computedTranslateX()

    return connectDropTarget(
      connectDragSource(
        <div
          className="drag_item"
          style={{
            opacity,
            transform: `translateX(${translateX}px)`,
            transition: 'transform 300ms'
          }}
        >
          {node}
        </div>
      )
    )
  }
}
export default DropTarget('item', specificationDrop, collectDrop)(
  DragSource('item', specificationDrag, collectDrag)(UploadItem)
)
